import * as React from "react";
import { CorrectionBreakdownItem } from "./CorrectionBreakdownItem";
import { Correction, MiscCorrection } from "../Request/DcfRequestReducer";
import RecordingStartPreview from "./CorrectionTypes/RecordingStart/RecordingStartPreviewItem";
import SubjectIdPreview from "./CorrectionTypes/SubjectId/SubjectIdPreviewItem";
import { CorrectionItemPreview } from "./CorrectionTypes/WizardTypings";
import SubjectTypePreview from "./CorrectionTypes/SubjectType/SubjectTypePreviewItem";
import MediaSerialPreview from "./CorrectionTypes/MediaSerial/MediaSerialPreviewItem";
import EntityLabelPreview from "./CorrectionTypes/EntityLabels/EntityLabelPreviewItem";
import SuppressCoughSessionPreview from "./CorrectionTypes/SuppressCoughSession/SuppressCoughSessionPreviewItem";
import { SwapLabelsPreview } from "./CorrectionTypes/SwapLabels/SwapLabelsPreview";

const PreviewItems: CorrectionItemPreview[] = [
    RecordingStartPreview,
    SubjectIdPreview,
    SubjectTypePreview,
    SuppressCoughSessionPreview,
    EntityLabelPreview,
    MediaSerialPreview,
    SwapLabelsPreview,
];

export interface CorrectionPreviewProps {
    corrections: Correction[];
    miscCorrection: MiscCorrection;
}

const GetElement = (corrections: Correction[]) => {
    return PreviewItems.find(pi => pi.previewSelector(corrections))?.previewElement;
};

export const CorrectionPreview = ({
    corrections,
    miscCorrection
}: CorrectionPreviewProps): JSX.Element => {
    if (corrections.length === 0 && miscCorrection === null) {
        return null;
    }

    const el = GetElement(corrections);

    let breakdownElement = null;
    if (el) {
        breakdownElement = React.createElement(el, {
            corrections: corrections,
            key: `BreakdownItem`
        });
    }

    return (
        <>
            {breakdownElement}
            {miscCorrection ? (
                <CorrectionBreakdownItem
                    key={`BreakdownItemMiscCorrection`}
                    fieldName={"Misc Correction"}
                    from={miscCorrection.fromDetails}
                    to={miscCorrection.toDetails}
                />
            ) : null}
        </>
    );
};
